(() => {
  const removals = new WeakMap();

  customElements.whenDefined('cart-drawer-items').then(() => {
    const CartDrawerItems = customElements.get('cart-drawer-items');
    const prototype = CartDrawerItems && CartDrawerItems.prototype;
    if (!prototype || prototype.mvRemovalMessageFixInstalled) return;

    const updateQuantity = prototype.updateQuantity;
    const updateLiveRegions = prototype.updateLiveRegions;
    if (typeof updateQuantity !== 'function' || typeof updateLiveRegions !== 'function') return;

    Object.defineProperty(prototype, 'mvRemovalMessageFixInstalled', { value: true });

    prototype.updateQuantity = async function (line, quantity, ...args) {
      const input = document.getElementById(`Drawer-quantity-${line}`);
      const oldQuantity = Number(input && input.getAttribute('value'));
      const oldTotal = Number(input && input.dataset.cartQuantity);
      const variantId = input && input.dataset.quantityVariantId;
      const context = Number(quantity) === 0 && input && variantId &&
        Number.isFinite(oldQuantity) && oldQuantity > 0 &&
        Number.isFinite(oldTotal) && oldTotal >= oldQuantity
        ? { line: String(line), input, variantId, expectedTotal: oldTotal - oldQuantity }
        : null;
      const previous = removals.get(this);
      if (context) removals.set(this, context);

      try {
        return await updateQuantity.call(this, line, quantity, ...args);
      } finally {
        if (context && removals.get(this) === context) {
          if (previous) removals.set(this, previous);
          else removals.delete(this);
        }
      }
    };

    prototype.updateLiveRegions = function (line, message, ...args) {
      const context = removals.get(this);
      const currentInput = document.getElementById(`Drawer-quantity-${line}`);
      const template = window.cartStrings && window.cartStrings.quantityError;
      const isInferredQuantityMessage = currentInput && typeof template === 'string' &&
        message === template.replace('[quantity]', currentInput.value);

      if (context && context.line === String(line) && !context.input.isConnected &&
          isInferredQuantityMessage) {
        const drawerItems = document.querySelector('cart-drawer-items');
        if (drawerItems) {
          const matchingInputs = Array.from(
            drawerItems.querySelectorAll('input[data-quantity-variant-id]')
          ).filter(input => input.dataset.quantityVariantId === context.variantId);
          const quantities = matchingInputs.map(input => Number(input.value));
          if (quantities.every(Number.isFinite)) {
            const actualTotal = quantities.reduce((sum, value) => sum + value, 0);
            if (actualTotal === context.expectedTotal) message = '';
          }
        }
      }

      return updateLiveRegions.call(this, line, message, ...args);
    };
  });
})();
